import React from "react";
import { useOrderDetailCtx } from "../../../../../context_providers/order_detail_context";

const CustomerInformation = () => {
  const { order } = useOrderDetailCtx();

  const customerData = {
    name:
      (order?.customer?.firstName || order?.customer?.first_name || "") +
      " " +
      (order?.customer?.lastName || order?.customer?.last_name || ""),
    group: order?.customer?.additional_customer_details?.customer_group ?? "--",
    type: order?.customer?.additional_customer_details?.customer_type ?? "--",
    segment: order?.customer?.additional_customer_details?.lead_segment ?? "--",
    gstNumber:
      order?.customer?.gst_details?.gst_number ?? order?.customer?.gst ?? "--",
    gstDetails: order?.customer?.gst_details?.gst_registration ?? "--",
    mobile: (order?.customer?.mobile || order?.customer?.alt_mobile) ?? "--",
    email:
      (order?.customer?.email ||
        order?.customer?.customer_contact_details?.email) ??
      "--",
  };

  return (
    <div className="bg-white   rounded-md text-sm  h-full">
      <div className="p-5">
        <div className="flex flex-row justify-end gap-1.5 sm:gap-5"></div>
        <div className="space-y-4">
          <div className="flex flex-col justify-between sm:flex-row sm:items-center gap-1 sm:gap-5">
            <div className="basis-1/3 shrink-0 text-sm font-medium text-gray-600">
              Customer Name
            </div>

            <div className="font-semibold sm:font-normal sm:text-right">
              {customerData.name}
            </div>
          </div>

          <div className="flex flex-col justify-between sm:flex-row sm:items-center gap-1 sm:gap-5">
            <div className="basis-1/3 shrink-0 text-sm font-medium text-gray-600">
              Customer Group
            </div>

            <div className="font-semibold sm:font-normal sm:text-right">
              {customerData.group}
            </div>
          </div>

          <div className="flex flex-col justify-between sm:flex-row sm:items-center gap-1 sm:gap-5">
            <div className="basis-1/3 shrink-0 text-sm font-medium text-gray-600">
              Customer Type
            </div>

            <div className="font-semibold sm:font-normal sm:text-right">
              {customerData.type}
            </div>
          </div>

          <div className="flex flex-col justify-between sm:flex-row sm:items-center gap-1 sm:gap-5">
            <div className="basis-1/3 shrink-0 text-sm font-medium text-gray-600">
              GST Number
            </div>

            <div className="font-semibold sm:font-normal sm:text-right">
              {customerData.gstNumber}
            </div>
          </div>

          <div className="flex flex-col justify-between sm:flex-row sm:items-center gap-1 sm:gap-5">
            <div className="basis-1/3 shrink-0 text-sm font-medium text-gray-600">
              GST Details
            </div>

            <div className="font-semibold sm:font-normal sm:text-right">
              {customerData.gstDetails}
            </div>
          </div>

          <div className="flex flex-col justify-between sm:flex-row sm:items-center gap-1 sm:gap-5">
            <div className="basis-1/3 shrink-0 text-sm font-medium text-gray-600">
              Lead Segment
            </div>

            <div className="font-semibold sm:font-normal sm:text-right">
              {customerData.segment}
            </div>
          </div>

          <div className="flex flex-col justify-between sm:flex-row sm:items-center gap-1 sm:gap-5">
            <div className="basis-1/3 shrink-0 text-sm font-medium text-gray-600">
              Contact No.
            </div>

            <div className="font-semibold sm:font-normal sm:text-right">
              {customerData.mobile}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-1 sm:gap-5">
            <div className="basis-1/3 shrink-0 text-sm font-medium text-gray-600 ">
              Email
            </div>

            <div className="font-semibold sm:font-normal sm:text-right">
              {customerData.email}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerInformation;
